import { useEffect, useRef } from 'react';

export const useContentHeightCalculation = () => {
  const contentRef = useRef(null);
  const mainRef = useRef(null);

  useEffect(() => {
    const addBottomPadding = () => {
      if (!contentRef.current) return;
      
      const content = contentRef.current;
      
      // Only apply on mobile
      if (window.innerWidth > 640) return;
      
      // Simply add bottom padding to prevent overlap with bottomPanel
      // This ensures content is always visible above the fixed bottomPanel
      content.style.paddingBottom = '100px';
    };

    // Run after a short delay to ensure DOM is ready
    const timer = setTimeout(addBottomPadding, 100);
    
    // Also run when window resizes
    const handleResize = () => {
      addBottomPadding();
    };
    
    window.addEventListener('resize', handleResize);
    
    return () => {
      clearTimeout(timer);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return { contentRef, mainRef };
}; 